export default {
  fanli: [{
      title: '返利到账时间',
      cont: `<p>1.返利申请，最好在充值当天申请，最晚申请一般不用超过一周，过时太久则不受理；<br>2.返利一般会在申请后，48小时内完成发放；  （具体联系客服）<br>3.部分游戏周末或节假日返利会稍有延迟，入有延迟一般会在工作日尽快安排发放，无需担心；<br>注意：当日的返利申请，建议在确认总金额后再提交，避免申请后继续充值错过更高的返还奖励；如若延期，确定返利依旧未收到，可联系客服协助核实；</p>`
    },
    {
      title: '返利未到账方式',
      cont: `返利到账形式一般有以下几种：<br />
      1.发放在游戏内邮件中，注意查收领取；<br />
      2.直接发放到背包中，需要使用后才可获得奖励（如元宝卡、礼包等）<br />
      3.在游戏界面某个【领奖】图标中进行领取；<br />
      4.激活码形式发放，联系客服领取，然后在游戏内激活；<br />
      5.直接发放到角色，需要自己留意金额道具相关变化；<br />`
    },
    {
      title: '平台币不到账',
      cont: `1.查看充值是否成功；<br />
      2.注意查看其游戏内充值是否忘记点折扣券<br />
      3.联系客服协助<br />
      <br />`
    },
    {
      title: '如何查看角色ID',
      cont: `不同游戏角色ID查看方法不同，但基本类型如下：<br />
      1.点开游戏内角色头像，可查看角色ID；<br />
      2.点击游戏内设置选项，可查看角色ID；<br />
      3.如果没有ID，可不提供<br />
      <br />`
    },
  ], //返利
  chongzhi: [{
      title: '充值未到账',
      cont: `1.【账号登陆错误】请确认登陆账号和充值账号是否一致；<br />
      2.【未支付成功】请确认是否正常通过支付宝或微信付款成功；<br />
      3.【其它故障】支付成功，但游戏未到账，可退出游戏后重新登陆查看，如果依然存在问题，请联系客服协助（另外每笔订单支付间隔不用过短，低于一分钟的多笔支付可能存在充值异常导致无法到账）<br />
      <br />`
    },
    {
      title: '支付限额怎么办',
      cont: `1.切换支付方式；<br />
      2.当支付达到商户限额，可尝试切换稳定网络或4G体检，并适度降低单笔充值额度，分多次支付一般即可避免。<br />
      3.如果游戏内或者活动有单笔充值金额要求，可选择支付够买平台币，然后游戏内充值选择用平台币一次性付款（可联系客服购买平台币）<br />
      <br />`
    },
  ], // 充值
  account: [{
      title: '忘记账号',
      cont: `账号充值过；联系客服提供任意一笔订单支付记录或支付记录截图，绑定手机号；即可帮您查到对应账号`
    },
    {
      title: '忘记密码',
      cont: `【有绑定手机-号码可用】可通过忘记密码选项进行自助进行找回修改密码；<br />
      【有绑定手机-号码无用】可向客服提供账号和支付宝、微信支付方式的历史记录截图核实；如未涉及账号交易或账号共享，且充值记录核实无误则可以找回；<br />
      【未绑定手机-有充值过】可向客服提供账号和支付宝、微信支付方式的历史支付记录截图，核实找回。<br />`
    },
    {
      title: '如何换绑手机',
      cont: `<p>
      1.在手机绑定功能内，通过当前绑定的手机短信验证后即可换绑；
    </p>
    <p>
      2.如果之前绑定手机不可用，可像客服提供账号和支付宝、微信支付方式的历史支付记录截图，进行核实，未涉及账号交易或账号共享，且充值记录核实无误才可以协助换绑；
    </p>`
    },
    {
      title: '账号被盗',
      cont: `郑重声明:请合理保护个人账号信息;凡线下交易、账号共享导致的账号纠纷问题，官方不予受理;<br />
      为什么不受理线下交易、账号共享的纠纷问题:<br />
      ①线下交易、账号共享等产生的纠纷,没有明确的交易流程和单号证据，且聊天截图、转账截图等均可伪造，基本无法判断事实真伪，故无法根据双方说辞判断真正归属，因此建议珍惜自己的账号财产。<br />
      ②从本质意义而言，账号共享、线下交易本就是自身对个人账户财产安全的不负责。以下三种情况最容易导致账号安全问题:使用辅助工具、账号线下交易、账号共享给其他用户导致信息被修改。<br />`
    },
  ], // 账号
  other: [{
      title: '下载登陆异常',
      cont: `【登录异常】<br />
      ①无法进入游戏--请检查当前游戏是否是维护中，如服务器正常可联系客服咨询;<br />
      ②无限登录账号--联系客服核实是否为服务器故障;<br />
      ③卡更新进度条--切换网络尝试或检查存储空间是否充足; [长时间未登录进入保护状态]保护状态是对用户账号安全的一种自动保护设置;遇到此类问题可直接联系客服协助恢复即可正常登录;<br />`
    },
    {
      title: '设置信任',
      cont: `[设置]--[通用]--[设备管理]-- [文件描述]--[信任文件]`
    },
  ], // 其他
}